import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchSvgs } from "../../../actions/sticker_maker/assetsActions";
import { useAppDispatch } from "../../../store/hooks";
import { setNewParams } from "../../../store/sticker_maker/assetsSlice";
import { queryParams } from "../../../helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Assets/_partials/_PageHeader";
import List from "../Assets/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import New from "./New";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";

const LIMIT = 42;

const Svgs = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['date_from', 'date_to']
    );

    dispatch(fetchSvgs(params));
  }, [searchParams, currentPage, dispatch]);

  function onClickCreate() {
    dispatch(setNewParams({ target: 1 }));
  }

  return (
    <PageLayout>
      <PageHeader />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Svg
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <List limit={LIMIT} />
        <New />
      </div>
    </PageLayout>
  );
}

export default Svgs;
